$(document).ready(function(){
    if(typeof pursesForm !== 'undefined') {
        reloadPurses = function () {
            //Ограничение действий для валют
            if(!pursesForm.autoExchange && pursesForm.currency != 'UAH')
            {
                pursesForm.method = null;
                if(pursesForm.selectedAction == 'replenishment')
                {
                    pursesForm.selectedAction = null;
                    alert(__('replenishment_wallet_not_possible'))
                }
            }

            //выделяем валюту
            $('.purse-table').each(function () {
                $(this).toggleClass('active', $(this).attr('id') == 'currency-' + pursesForm.currency);
            });

            if (!pursesForm.currency) pursesForm.showActions = false;

            //показываем или скрываем кнопку управления кошельками
            $('#purse-control').toggleClass('disabled', !(pursesForm.currency));

            //Отображение "выберите действие"
            $('#select-action').toggle(!!pursesForm.currency);

            if (!pursesForm.currency) pursesForm.selectedAction = false;

            $('.purse-action').each(function () {
                $(this).toggleClass('active', $(this).attr('id') == 'action-' + pursesForm.selectedAction);
            });
            //трансфер денег

            $('#transfer-action').toggle(pursesForm.selectedAction == 'transfer');

            if (pursesForm.selectedAction == 'transfer')
            {
                $('#transfer-block').html('<img src="/public/frontend/images/ajaxLoader.gif">');
                $.ajax({
                    url:'/profile/finance_settings/ajax_remittance_view/' + pursesObject[pursesForm.currency],
                    success: function(html)
                    {
                        $('#transfer-block').html(html)
                    }
                })
            }
            $('#transfer_mobile-action').toggle(pursesForm.selectedAction == 'transfer_mobile');
            if (pursesForm.selectedAction == 'transfer_mobile')
            {
                $('#transfer-block').html('<img src="/public/frontend/images/ajaxLoader.gif">');
                $.ajax({
                    url:'/profile/finance_settings/ajax_remittance_view_mobile/' + pursesObject[pursesForm.currency],
                    success: function(html)
                    {
                        $('#transfer-block').html(html)
                    }
                })
            }
            //выберите метод оплаты
            $('#select-method').toggle((pursesForm.selectedAction == 'replenishment'));

            if (!pursesForm.selectedAction) pursesForm.method = null;

            $('.pay-method').each(function () {
                $(this).toggleClass('active', $(this).attr('id') == 'method-' + pursesForm.method);
            });

            //укажите сумму оплаты

            $('#paying-action').toggle(pursesForm.method == 'mastercard' || pursesForm.method == 'visa');

            $('#form-currency').val(pursesForm.currency);
            if (pursesForm.method == 'mastercard') $('#form-method').val('2');
            if (pursesForm.method == 'visa') $('#form-method').val('2');
            /*if (pursesForm.method == 'easypay') $('#form-method').val('2');*/
            /*if (pursesForm.method == 'mastercard') $('#form-method').val('1');
            if (pursesForm.method == 'privat') $('#form-method').val('1');
            if (pursesForm.method == 'easypay') $('#form-method').val('2');*/
        };

        reloadPurses();

        window.setPursesParam = function (param, value) {
            pursesForm[param] = value;
            if(param == 'method' && !(value == 'mastercard' || value == 'visa'))pursesForm.method=null;
            reloadPurses();
        };
    }

});